export default "__VITE_ASSET__e_SQTc8mQlfZN1R_ZcR$4w__";